import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const services = [
  {
    icon: 'ri-home-4-line',
    title: 'Haushaltsauflösung',
    description: 'Ob bei Umzug, Todesfall oder Wohnungswechsel – wir kümmern uns um die komplette Auflösung Ihres Haushalts. Wir räumen Wohnungen, Häuser, Keller und Dachböden fachgerecht und schnell.',
    details: [
      'Komplette Wohnungsauflösungen',
      'Keller- und Dachbodenräumung',
      'Fachgerechte Entsorgung',
      'Schnelle & zuverlässige Abwicklung',
    ],
    image: 'https://public.readdy.ai/ai/img_res/8f8fb85eea93320adcf4f340e465cdeb.jpg',
  },
  {
    icon: 'ri-delete-bin-line',
    title: 'Entrümpelung aller Art',
    description: 'Wir entrümpeln Gewerbe- und Privaträume, Keller, Garagen und Gartenhäuser. Unabhängig von der Größe oder dem Zustand des zu entrümpelnden Objekts stehen wir Ihnen zur Seite und sorgen für eine gründliche und umweltfreundliche Entsorgung.',
    details: [
      'Privat- & Gewerberäume',
      'Keller, Garagen & Gartenhäuser',
      'Umweltfreundliche Entsorgung',
      'Auf Wunsch Wertanrechnung',
    ],
    image: 'https://readdy.ai/api/search-image?query=professional%20junk%20removal%20team%20clearing%20out%20a%20cluttered%20basement%20or%20garage%2C%20workers%20in%20orange%20uniforms%20sorting%20items%2C%20clean%20bright%20background%2C%20organized%20and%20efficient%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=ls2&orientation=landscape',
  },
  {
    icon: 'ri-truck-line',
    title: 'Möbeltaxi',
    description: 'Wir bieten Ihnen nicht nur einen zuverlässigen Transport Ihrer Möbel und Gegenstände, sondern auch klare und transparente Preise. Innerhalb Hildesheim: 35€/Std. ohne Helfer, 60€/Std. mit Helfer. Im Landkreis: +10€/Std.',
    details: [
      'Innerhalb Hildesheim: 35€/Std. ohne Helfer',
      'Mit Helfer: 60€/Std.',
      'Im Landkreis: +10€/Std.',
      'Transparente Festpreise',
    ],
    image: 'https://readdy.ai/api/search-image?query=moving%20van%20truck%20parked%20in%20front%20of%20a%20residential%20building%20in%20Germany%2C%20workers%20loading%20furniture%2C%20orange%20branded%20vehicle%2C%20sunny%20day%2C%20clean%20street%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=ls3&orientation=landscape',
  },
  {
    icon: 'ri-box-3-line',
    title: 'Kleine Umzüge',
    description: 'Auch bei kleineren Umzügen stehen wir Ihnen gerne zur Verfügung. Ob ein Zimmer, eine Wohnung oder ein kleines Büro – wir sorgen für einen problemlosen Umzug und einen reibungslosen Transport Ihrer Möbel und Gegenstände.',
    details: [
      'Zimmer- & Wohnungsumzüge',
      'Büroumzüge',
      'Sorgfältiger Möbeltransport',
      'Flexibel & termingerecht',
    ],
    image: 'https://readdy.ai/api/search-image?query=small%20apartment%20moving%20service%20in%20Germany%2C%20workers%20carefully%20carrying%20boxes%20and%20furniture%20down%20stairs%2C%20orange%20uniforms%2C%20bright%20stairwell%2C%20professional%20and%20friendly%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=ls4&orientation=landscape',
  },
  {
    icon: 'ri-money-euro-circle-line',
    title: 'Ankauf von Wertgegenständen',
    description: 'Sie haben wertvolle Einzelstücke, Antiquitäten oder andere Wertgegenstände? Wir kaufen diese gerne an und sorgen für eine faire Bewertung und einen reibungslosen Ankaufsprozess.',
    details: [
      'Antiquitäten & Sammlerstücke',
      'Möbel & Einrichtungsgegenstände',
      'Faire Bewertung vor Ort',
      'Unkomplizierter Ankaufsprozess',
    ],
    image: 'https://readdy.ai/api/search-image?query=antique%20valuables%20assessment%20scene%2C%20professional%20appraiser%20examining%20vintage%20furniture%20and%20collectibles%20in%20a%20bright%20room%2C%20warm%20lighting%2C%20elegant%20items%20on%20display%2C%20clean%20simple%20background%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=ls5&orientation=landscape',
  },
];

const reasons = [
  { icon: 'ri-shield-check-line', title: 'Zuverlässig & pünktlich', text: 'Wir halten unsere Termine ein und arbeiten schnell und sorgfältig.' },
  { icon: 'ri-price-tag-3-line', title: 'Faire Preise', text: 'Transparente Festpreise ohne versteckte Kosten – Sie wissen immer, was Sie zahlen.' },
  { icon: 'ri-recycle-line', title: 'Umweltfreundlich', text: 'Fachgerechte und umweltbewusste Entsorgung aller Materialien.' },
  { icon: 'ri-map-pin-line', title: 'Regional verwurzelt', text: 'Wir kennen Hildesheim und die Region – schnell vor Ort und persönlich.' },
];

export default function Leistungen() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-20 overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=professional%20house%20service%20team%20in%20orange%20t-shirts%20with%20Picobello%20Hausservice%20logo%20printed%20on%20chest%2C%20standing%20confidently%20in%20front%20of%20a%20modern%20German%20residential%20building%2C%20white%20logo%20text%20on%20orange%20shirts%2C%20sunny%20day%2C%20clean%20street%2C%20friendly%20smiling%20team%20of%203%20workers%2C%20photorealistic%2C%20high%20quality%2C%20sharp%20details&width=1440&height=600&seq=lshero2&orientation=landscape')" }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60" />
          <div className="relative container mx-auto px-4 text-center w-full">
            <span className="inline-block bg-orange-500 text-white text-sm font-semibold px-4 py-1.5 rounded-full mb-4 tracking-wide">
              Unsere Leistungen
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Alles aus einer Hand –<br />
              <span className="text-orange-400">professionell & fair</span>
            </h1>
            <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-8">
              Von der Haushaltsauflösung bis zum Möbeltaxi – Picobello Hausservice ist Ihr zuverlässiger Partner in Hildesheim und Umgebung.
            </p>
            <a
              href="tel:015758089488"
              className="inline-block bg-orange-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-orange-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>Jetzt kostenlos anfragen
            </a>
          </div>
        </section>

        {/* Services Detail */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="space-y-20">
              {services.map((service, index) => (
                <div
                  key={index}
                  className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
                >
                  {/* Image */}
                  <div className="w-full lg:w-1/2">
                    <div className="w-full h-72 rounded-2xl overflow-hidden shadow-lg">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                  {/* Content */}
                  <div className="w-full lg:w-1/2">
                    <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center mb-5">
                      <i className={`${service.icon} text-2xl text-orange-500`}></i>
                    </div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">{service.title}</h2>
                    <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
                    <ul className="space-y-2 mb-8">
                      {service.details.map((detail, i) => (
                        <li key={i} className="flex items-center gap-3 text-gray-700 text-sm">
                          <span className="w-5 h-5 flex items-center justify-center">
                            <i className="ri-check-line text-orange-500 text-lg"></i>
                          </span>
                          {detail}
                        </li>
                      ))}
                    </ul>
                    <Link
                      to="/#buchung"
                      className="inline-block bg-orange-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-orange-600 transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
                    >
                      Jetzt anfragen
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Us */}
        <section className="py-20 bg-orange-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-14">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Warum Picobello Hausservice?</h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Unser umfangreiches Leistungsangebot bietet Ihnen die Flexibilität und Zuverlässigkeit, die Sie von einem professionellen Unternehmen erwarten.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {reasons.map((r, i) => (
                <div key={i} className="bg-white rounded-2xl p-8 text-center shadow-sm hover:shadow-md transition-shadow">
                  <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-5">
                    <i className={`${r.icon} text-2xl text-orange-500`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{r.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{r.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-14">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">So einfach geht's</h2>
              <p className="text-gray-600 max-w-xl mx-auto">In nur 3 Schritten zu Ihrem Wunschtermin.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              {[
                { icon: 'ri-phone-line', step: '1', title: 'Kontakt', text: 'Sie kontaktieren uns telefonisch, per E-Mail oder über das Buchungsformular.' },
                { icon: 'ri-file-list-3-line', step: '2', title: 'Angebot', text: 'Sie erhalten umgehend ein kostenloses und unverbindliches Angebot von uns.' },
                { icon: 'ri-hand-heart-line', step: '3', title: 'Umsetzung', text: 'Wir kümmern uns zuverlässig und pünktlich um Ihr Anliegen.' },
              ].map((item, i) => (
                <div key={i} className="text-center relative">
                  <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-5 relative">
                    <i className={`${item.icon} text-3xl text-orange-500`}></i>
                    <span className="absolute -top-1 -right-1 w-7 h-7 bg-orange-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
                      {item.step}
                    </span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-3">{item.title}</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-gradient-to-br from-orange-500 to-orange-600">
          <div className="container mx-auto px-4 text-center w-full">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Bereit für Ihren Auftrag?</h2>
            <p className="text-white/90 text-lg mb-8 max-w-xl mx-auto">
              Kontaktieren Sie uns jetzt – wir melden uns schnell und unkompliziert bei Ihnen.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:015758089488"
                className="inline-block bg-white text-orange-500 px-8 py-4 rounded-full font-semibold text-lg hover:bg-orange-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>015758089488
              </a>
              <Link
                to="/#buchung"
                className="inline-block border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                Zum Buchungsformular
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
